module.exports = __webpack_public_path__ + "static/Cisco-Webex-def54f37935ba88a59d346f682ac28cb.png";